var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('div',{attrs:{"id":"wrapper"}},[_c('SideBar'),_c('button',{staticClass:"btn btn-default",attrs:{"id":"menu-toggle"},on:{"click":_vm.toggleMenu}},[_c('i',{staticClass:"fa fa-bars"})]),_c('div',{attrs:{"id":"page-content-wrapper"}},[_c('div',{staticClass:"container-fluid"},[_c('router-view')],1)])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }